module.exports = __webpack_public_path__ + "dbb1f49e4b3178614043747c6b172ee6.svg";